module.exports = __webpack_public_path__ + "files/256d6b57db222e23859da0ac4d8dafbd.png";